import type { IProductRequest } from "../../Interfaces/IProductRequest"
import { drinksMemory, mealsMemory } from "../../Objects/Memory/Memory"
import type { RodizioPlan } from "../../Objects/Rodizio/RodizioPlan"

export const getRodizioGenericFoodId = (product: IProductRequest): number | undefined => {
  if (product.id.startsWith("meal-")) {
    return mealsMemory.listData.find((item) => item.id === Number(product.id.replace("meal-", "")))
      ?.genericFoodEntity.id
  }

  if (product.id.startsWith("drink-")) {
    return drinksMemory.listData.find((item) => item.id === Number(product.id.replace("drink-", "")))
      ?.genericFoodEntity.id
  }

  return undefined
}

const findGenericFoodName = (genericFoodId: number): string | undefined => {
  const meal = mealsMemory.listData.find((item) => item.genericFoodEntity.id === genericFoodId)

  if (meal) return meal.genericFoodEntity.name

  const drink = drinksMemory.listData.find((item) => item.genericFoodEntity.id === genericFoodId)

  return drink?.genericFoodEntity.name
}

export interface RodizioPlanProductIndexEntry {
  plan: RodizioPlan
  subProductNames: string[]
}

export const buildRodizioPlanProductIndex = (plans: RodizioPlan[]): Map<string, RodizioPlanProductIndexEntry> => {
  const index = new Map<string, RodizioPlanProductIndexEntry>()

  plans
    .filter((plan) => plan.isActive)
    .forEach((plan) => {
      index.set(`meal-${plan.chargeMealEntityId}`, {
        plan,
        subProductNames: plan.productIds
          .map((genericFoodId) => findGenericFoodName(genericFoodId))
          .filter((name): name is string => Boolean(name)),
      })
    })

  return index
}
